import React from "react"
import { SavedColorsProvider } from "@kit/design/color-input"
import { useSavedColors } from "hooks/use-saved-colors"

/**
 * Gives every color field in the app the account's saved colors. Mounted at
 * the app's roots, since saved colors belong to the account, not a page.
 */
export function AccountSavedColors({ children }) {
  const savedColors = useSavedColors()

  return (
    <SavedColorsProvider savedColors={savedColors}>
      {children}
    </SavedColorsProvider>
  )
}
